/**
 * Utility functions for tour testing and debugging
 */

/**
 * Reset all tour completion status from localStorage
 */
export const resetAllTours = () => {
  console.log('Resetting all tours...');
  
  // Clear all tour completion flags from localStorage
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('tour_')) {
      console.log('Removing tour flag:', key);
      localStorage.removeItem(key);
    }
  }
  
  console.log('All tours have been reset.');
};

/**
 * Check if a specific tour has been completed
 * @param {string} route - The route to check (e.g., '/talent/dataimport')
 * @returns {boolean} - True if the tour has been completed
 */
export const isTourCompleted = (route) => {
  const key = `tour_${route}`;
  return localStorage.getItem(key) === 'true';
};

/**
 * Mark a tour as completed
 * @param {string} route - The route to mark as completed
 */
export const markTourAsCompleted = (route) => {
  const key = `tour_${route}`;
  localStorage.setItem(key, 'true');
  console.log(`Tour for ${route} marked as completed.`);
};

/**
 * List all completed tours
 * @returns {Array} - Array of completed tour routes
 */
export const listCompletedTours = () => {
  const completedTours = [];
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('tour_')) {
      const route = key.replace('tour_', '');
      completedTours.push(route);
    }
  }
  
  return completedTours;
};

export default {
  resetAllTours,
  isTourCompleted,
  markTourAsCompleted,
  listCompletedTours
};